module.exports = __webpack_public_path__ + "img/recipes_icon.da6b932b.svg";